<template>
    <div>
        <vx-card title="Available packages" id="packagesDiv"  class="vs-con-loading__container">
            <vs-table ref="availablePackagesTable" :data="tableData" pagination search :maxItems="itemsPerPage">

                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="days">Days</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                    <vs-th sort-key="trial_status">Trial</vs-th>
                    <vs-th sort-key="trial_days">Trial days</vs-th>
                    <vs-th sort-key="active">Active</vs-th>
                    <vs-th></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].days">
                            {{ data[index].days }}
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                        <vs-td :data="data[index].trial_status" class="flex pt-5">
                            <vs-chip v-if="data[index].trial_status === 0" color="danger">Not available</vs-chip>
                            <vs-chip v-if="data[index].trial_status === 1" color="success">Available</vs-chip>
                            <vx-tooltip v-if="data[index].trial_status === 2" :text="'Activated on ' + moment(data[index].trial_activation).format('YYYY/MM/DD HH:mm:ss')" ><vs-chip color="warning">Used</vs-chip></vx-tooltip>

                        </vs-td>

                        <vs-td :data="data[index].trial_days">
                            {{ (data[index].trial_status === 1 || data[index].trial_status === 2) ? data[index].trial_days : 0 }}
                        </vs-td>

                        <vs-td :data="data[index].active" class="flex pt-5">
                            <vx-tooltip v-if="data[index].active" :text="'Until ' + moment(data[index].active_until).format('YYYY/MM/DD HH:mm:ss')" ><vs-chip color="success">Yes</vs-chip></vx-tooltip>
                            <vs-chip v-else color="danger">No</vs-chip>
                        </vs-td>

                        <vs-td>
                            <vs-button v-if="!data[index].active" style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-play" color="success" class="md:mb-0 mr-3 mb-1" @click="openActivationPrompt(data[index])">Activate</vs-button>
                            <vs-button v-else style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-play" color="success" class="md:mb-0 mr-3 mb-1" @click="openActivationPrompt(data[index])">Extend</vs-button>
                            <vs-button v-if="data[index].trial_status === 1" style="float: left" :size="($store.state.windowWidth > 1000) ? 'normal' : 'small'" icon-pack="feather" icon="icon-zap" color="warning" class="md:mb-0 mr-3 mb-1" @click="openTrialActivationPrompt(data[index])">Trial</vs-button>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
    </div>
</template>
<script>

    export default {
        props: {
            clientId: {
                type: Number,
                required: true
            }
        },
        data() {
            return {

                itemsPerPage: 10,
                isMounted: false,

                packages: []

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#packagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const packagesPromise = this.$http.get('/api/management/v1/client/' + this.clientId + '/package')
                packagesPromise.then(function(response) {
                    thisIns.packages = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packagesDiv > .con-vs-loading')
                })
            },
            openActivationPrompt(obj) {
                const thisIns = this

                this.$vs.dialog({
                    type: 'confirm',
                    color: 'success',
                    title: 'Activate',
                    text: 'Are you sure you want to activate package ' + obj.name + '?',
                    accept: function() { thisIns.activatePackage(obj.id) }
                })
            },
            openTrialActivationPrompt(obj) {
                const thisIns = this

                this.$vs.dialog({
                    type: 'confirm',
                    color: 'warning',
                    title: 'Activate trial',
                    text: 'Are you sure you want to activate trial for package ' + obj.name + '?',
                    accept: function() { thisIns.activatePackageTrial(obj.id) }
                })
            },
            activatePackage(id) {
                this.$vs.loading({
                    container: '#packagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const activatePromise = this.$http.put('/api/management/v1/client/' + this.clientId + '/package/' + id)
                activatePromise.then(function() {
                    thisIns.loadData()
                    thisIns.$emit('activation')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packagesDiv > .con-vs-loading')
                })
            },
            activatePackageTrial(id) {
                this.$vs.loading({
                    container: '#packagesDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const activatePromise = this.$http.put('/api/management/v1/client/' + this.clientId + '/package/' + id + '/trial')
                activatePromise.then(function() {
                    thisIns.loadData()
                    thisIns.$emit('activation')
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#packagesDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.availablePackagesTable.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.availablePackagesTable.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.packages
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
